<template>
  <b-card bg-variant="light" class="m-1">
    <b-row class="m-3">
      <b-col>
        <h3 class="text-secondary">3. Options</h3>
      </b-col>
    </b-row>
    <b-row class="m-3">
      <b-col md="6"> </b-col>
      <b-col>
        <b-form-checkbox
          class="m-2"
          v-model="options.send_reminders"
          :value="true"
          :unchecked-value="false"
        >
          Send reminders
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button v-b-toggle.collapse-1 variant="info" class="m-3"
          >Toggle specification</b-button
        >
      </b-col>
      <b-col>
        <b-btn
          class="float-right m-3"
          variant="success"
          @click="importData"
          :disabled="this.final_data == null"
          >Import</b-btn
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-collapse id="collapse-1" class="m-2">
          <b-card>
            <b-row>
              <b-table class="m-3" small per-page="50" :items="spec_data">
              </b-table>
            </b-row>
          </b-card>
        </b-collapse>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
  props: {
    final_data: Array,
    spec_data: Array
  },
  data() {
    return {
      options: {
        brand: null,
        send_reminders: false
      }
    };
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    ...mapActions("axios_mod", ["simpleMutation"]),
    importData() {
      let dataJsonString = JSON.stringify(this.final_data);
      let dataJsonB64 = Buffer.from(dataJsonString).toString("base64");

      let data = {
        query: `
          mutation {
            res: ImportToolImportUsers (
              importDataBase64: "${dataJsonB64}",
              locale: "${this.options.locale}",
              companyId: ${parseInt(this.options.company_web_app_id)},
              hasAppAccess: ${this.options.has_app_access}
            ) { message }
          }
        `
      };

      this.simpleWebAppMutation({ data, this_ref: this }).then(() => {
        //this.selectedModel = null;
      });
    }
  }
};
</script>
